import React, { Component } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  Platform,
  ScrollView,
  StyleSheet,
  Animated,
  ImageBackground,
  ActivityIndicator,
  TouchableHighlight,
  SafeAreaView,
} from "react-native";
// import Share from 'react-native-share';
// import { WebView } from 'react-native-webview';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from 'react-native-vector-icons/FontAwesome';
// import { isIos, deviceWidth, deviceHeight, toFixed, shareImage } from './../Utils';
// import { TabView, TabBar, SceneMap } from 'react-native-tab-view';
// import AnalysisScreen from './analysisScreen';
// import AnswerScreen from './answerScreen';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import { resetAll } from './../../navigators/navigationService';
import { connect } from "react-redux";
// import { PieChart } from 'react-native-svg-charts';
import {
  testAnalysis,
  clearTestAnalysisData,
  questionReport,
  clearQuestionReportData,
} from "./../../store/actions";

import { BarChart, PieChart } from "./../../components/charts";
// import Collapsible from 'react-native-collapsible';
import Collapse from '@material-ui/core/Collapse';
import {
  Checkbox,
  TextInput,
  Surface,
  Button,
  Modal,
  Provider,
  Portal,
} from "react-native-paper";
// import Toast, { DURATION } from 'react-native-easy-toast';
import moment from "moment";
// import OfflineHandler from './../OfflineHandler';
// import CountDown from 'react-native-countdown-component';
// import ViewShot from "react-native-view-shot";
import {
  PRACTICE_TEST,
  PLANNED_TEST,
  CHALLENGE_TEST,
} from "./../../store/constants";
// import AdComponent from './../Ads';
import {
  Text,
  Styles,
  ConverToTextComponent,
} from "./../../components/UI-Components";
import Icon from "@material-ui/core/Icon";
import Header from "./../../components/Header";

import Create from "@material-ui/icons/Create";
import Container from "@material-ui/core/Container";
import Results from './resultsScreen'

const Loader = require("./../../assets/loadingGif.gif");

export function toFixed(x, y = 2) {
  return Number.parseFloat(x).toFixed(y);
}
// import ResultImageComponent from "./resultImageComponent";
// import Font from './../Colors';

// const barChart = isIos ? BarChart : Google_BarCharts;
// const pieChart = isIos ? _PieChart : PieChart_GoogleCharts;

// class PieChartExample extends React.Component {

//   state = {
//     collapsed: null,
//     score: 80,
//     data: [
//       {
//         key: 1,
//         value: 0,
//         svg: { fill: 'green' },
//         arc: { outerRadius: '115%', cornerRadius: 10, },
//         onPress: () => this.setArk(1)
//       },
//       {
//         key: 2,
//         value: 0,
//         svg: { fill: 'red' },
//         onPress: () => this.setArk(2)
//       }
//     ]
//   }

//   componentDidUpdate(prevProps) {
//     if (prevProps.score !== this.props.score) {
//       if (this.props.score && this.props.score.length) {

//         const _data = [];
//         this.state.data.map((d, i) => {
//           _data.push({ ...d, value: this.props.score[i] })
//         })
//         this.setState({
//           data: _data
//         })
//       }
//     }
//   }

//   setArk = (id) => {
//     const _data = this.state.data;
//     let score = null;

//     const data = _data.map(x => {
//       if (x.key == id) {
//         this.props.changeScore(x.value);
//         if (x.arc && x.arc.outerRadius === '115%') return { ...x, arc: {} }
//         return { ...x, arc: { outerRadius: '115%', cornerRadius: 10, } }
//       }
//       return { ...x, arc: {} }
//     })

//     this.setState({ data })

//   }

//   render() {
//     console.log(this.props, 'test analysis');

//     const { data } = this.state;

//     const randomColor = () => ('#' + (Math.random() * 0xFFFFFF << 0).toString(16) + '000000').slice(0, 7)

//     const pieData = data
//       .filter(value => value > 0)
//       .map((value, index) => ({
//         value,
//         svg: {
//           fill: randomColor(),
//           // onPress: () => { this.setState({ data }) },
//         },
//         key: `pie-${index}`,
//       }))

//     return (
//       <PieChart
//         style={{ height: 200 }}
//         outerRadius={'70%'}
//         innerRadius={10}
//         data={data}
//         animate={true}
//         animationDuration={500}
//         valueAccessor={({ item }) => item.value}
//       />
//     )
//   }

// }

const getColor = (ans) =>
  ans === "correct" ? "green" : ans === "wrong" ? "red" : "#000";

const OptionComponent = ({ isCorrect, i, option, isMathType }) => {
  const color = getColor(isCorrect);

  return (
    <View style={styles.question_gap}>
      <Text style={{ fontSize: 16, fontWeight: "400", marginTop: 2, color }}>
        {i}
      </Text>
      <View style={{ flex: 1 }}>
        <ConverToTextComponent
          text={option}
          color={color}
          isMathType={isMathType}
        />
      </View>
    </View>
  );
};

class TestAnalysisScreen extends React.Component {
  state = {
    modalVisible: false,
    // checked: false,
    questionCheck: false,
    answersCheck: false,
    explanationCheck: false,
    chart: true,
    testId: null,
    score: 80,
    index: 0,
    routes: [
      { key: "key", title: "Key" },
      //   { key: 'analysis', title: 'Analysis' },
    ],
    _score: [10, 90],
    test_details: {
      subject: "Indian Polity",
      questions: 10,
      attempt: 10,
      corrects: "10",
      wrongs: "02",
      isImageOpen: false,
    },
  };

  changeScore = (score) => this.setState({ score });

  //   static navigationOptions = ({navigation}) => ({
  //     headerRight:  (<Icon name={isIos ? 'ios-share' : 'md-share'} size={30} style={{ paddingLeft: 10, paddingRight: 20, color:'#000' }}
  //     onPress={() => {
  //       const shareImage = navigation.getParam('shareImage', null);
  //       if(typeof shareImage === 'function') {
  //         shareImage();
  //       }
  //      }}
  //     />)
  //   })

  componentDidMount() {
    this.fetchTestAnalysisData();
    // this.props.navigation.setParams({
    //   shareImage: this.shareImage
    // })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.correctQuestions !== this.props.correctQuestions) {
      if (this.props.correctQuestions) {
        const { test_type } = this.props.correctQuestions;
        if (test_type === PLANNED_TEST) {
          this.props.navigation.setParams({ plannedTest: true });
          this.setState({
            _isPlannedTest: true,
          });
        }
        if (test_type === CHALLENGE_TEST) {
          this.setState(
            {
              isImageOpen: false,
            },
            () => {
              // setTimeout(() => {
              //     this.backgroundImageClose();
              // }, 3000)
            }
          );
        }
      }
    }

    if (prevProps.totalQuestions !== this.props.totalQuestions) {
      if (this.props.totalQuestions) {
        this.setState({
          _score: [
            this.props.totalQuestions.correct_count,
            this.props.totalQuestions.wrong_count,
          ],
        });
      }
    }

    if (prevProps.err !== this.props.err) {
      if (this.props.err) {
        const errorMessage =
          this.props.errInfo || "Please wait for test result.";
        if (!this.props.remainingTimeForShowResult) {
          this.refs.toast.show(errorMessage, 1500);
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.clearTestAnalysisData();
  }

  fetchTestAnalysisData = () => {
    // const testId = this.props.navigation.getParam('testId', null);
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', null);
    // const isPlannedTest = this.props.navigation.getParam('isPlannedTest', false);
    const { state = {} } = this.props.location || {};
    const { testId = null, isTestSeries = null, isPlannedTest = null } =
      state || {};
    if (testId) {
      this.props.testAnalysis(testId, isPlannedTest, isTestSeries);
    }
  };

  isCorrectAnswer = (ans) =>
    ans === "correct"
      ? styles.correctAnswer
      : ans === "wrong"
        ? styles.wrongAnswer
        : {};

  highlightAnswers = (test, i) => {
    return test.correct_option === `option${i}`
      ? "correct"
      : test.correct_option !== `option${i}` &&
        test.user_option === `option${i}`
        ? "wrong"
        : null;
  };

  setModalVisible(visible) {
    this.setState({ modalVisible: visible });
    if (!visible) {
      this.setState({
        questionCheck: false,
        answersCheck: false,
        explanationCheck: false,
        eventDescription: "",
        submitClicked: false,
      });
    }
  }

  reportQuestion = () => {
    this.setState({ submitClicked: true });
    const {
      questionCheck,
      answersCheck,
      explanationCheck,
      eventDescription,
      collapsed, // question id
    } = this.state;

    const correction = [questionCheck, answersCheck, explanationCheck];
    let _correction_in = [];
    correction.map((c, i) => {
      if (c) {
        _correction_in.push(i + 1);
      }
    });

    const data = {
      test_id: this.props.requestedTestId,
      subject_id: 1,
      question_id: collapsed,
      correction_in: _correction_in.join(","),
      comments: eventDescription,
    };

    if (data && Object.keys(data).keys) {
      this.props.questionReport(data);
    }
  };

  //   shareImage = () => {
  //     if(!this.props.answers) return console.log('not loaded!!');
  //     this.refs.viewShot.capture().then(uri => {
  //       // console.log(uri, 'uri');
  //       const options = {
  //         url: uri,
  //         message: 'https://2thepoint.page.link/appLink',
  //       }
  //       shareImage(options);

  //     });
  //   }
  backgroundImageClose = () => {
    this.setState({
      isImageOpen: false,
    });
  };

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };

  render() {
    const { questionCheck, answersCheck, explanationCheck } = this.state;

    const {
      _score,
      submitTest,
      testQuestions,
      score,
      loading,
      err,
      answers,
      Data,
      userSubject,
      userScore,
      totalQuestions,
      wrongQuestions,
      correctQuestions,
      attemptUser,
      unansweredQuestions,
    } = this.props;
    const { subject_image, test_type } = correctQuestions || {};
    const { state = {} } = this.props.location || {};
    const { testId = null, isTestSeries = null, isPlannedTest = null } = state || {}
    return (
      <>
        {/* <Header
          title="Result"
          headerRight
          headerRightClick={() => this.props.history.push('/Home')}
          // backButton={true}
        /> */}
        {this.props.loading ? (
          <View
            style={{
              width: "100%",
              height: "90vh",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <ActivityIndicator /> */}
            <Image source={Loader} style={{ width: 250, height: 250 }} />
          </View>
        ) : null}

        {this.props.err &&
          !this.props.remainingTimeForShowResult &&
          !this.props.loading && (
            <View style={{ flex: 1, marginTop: 10 }}>
              <Text style={{ textAlign: "center" }}>
                {this.props.errInfo &&
                  typeof this.props.errInfo === "string"
                  ? this.props.errInfo
                  : "Something went wrong..."}
              </Text>
            </View>
          )}

        {
          !this.props.loading && this.props.answers && this.props.answers.length ? (
            <Results
              answers={this.props.answers}
              wrongQuestions={wrongQuestions && wrongQuestions.wrong_count}
              correctAnswer={correctQuestions && correctQuestions.correct_count}
              unansweredQuestions={unansweredQuestions}
              score={userScore && toFixed(userScore.user_score)}
              attemptUser={attemptUser}
              userSubject={userSubject}

            />

          ) : !this.props.loading &&
            this.props.answers &&
            !this.props.answers.length ? (
                <Text>No Data Found....</Text>
              ) : null
        }

      </>
    );
  }
}

const styles = StyleSheet.create({
  splashBackgroundImage: {
    flex: 1,
    // borderWidth:3,
    width: "100%",
    height: "100%",
    backgroundColor: "red",
    //  resizeMode: 'cover',
    //  alignItems:'center',
    //  justifyContent:'center'
  },
  mainContainer: {
    flex: 1,
    backgroundColor: "#fff",
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  roundBorder: {
    // flex: 1,
    // height: '100%',
    // flexDirection: 'row',
    marginVertical: 15,
    // marginHorizontal: 10,
    borderWidth: 0.7,
    borderColor: "#ccc",
    padding: 15,
    borderRadius: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  searchIcon: {
    marginRight: 10,
    paddingRight: 10,
    color: "#f4511e",
  },
  headingColor: {
    color: "#F5591F",
    fontSize: 18,
    fontWeight: "400",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
  },
  nameText: {
    marginLeft: 10,
    marginRight: 15,
    fontSize: 16,
    color: "#222",
    textAlign: "center",
    width: "50%",
    textAlign: "right",
  },
  scene: {
    flex: 1,
  },
  tabBar: {
    flexDirection: "row",
    // paddingTop: Constants.statusBarHeight,
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    fontSize: 30,
    // borderRightWidth: 1,
    // borderColor: 'red'
  },

  qstn_group: {
    marginBottom: 20,
    fontWeight: "700",
  },
  question: {
    fontSize: 14,
    fontWeight: "700",
    flexDirection: "row",
    // borderWidth:1
  },
  qstn_nbr: {
    fontWeight: "700",
    // paddingRight: 5,
    flex: 1,
  },
  question_gap: {
    width: "95%",
    marginVertical: 7,
    flex: 1,
    flexDirection: "row",
    marginLeft: 6,
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  answerText: {
    fontSize: 14,
    // marginVertical:10,
    fontWeight: "700",
    marginRight: 10,
  },
  correctAnswer: {
    color: "green",
  },
  wrongAnswer: {
    color: "red",
  },
  components: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginVertical: 3,
  },
});

const maps = (state) => ({
  loading:
    state.testAnalysis &&
    state.testAnalysis.loading &&
    state.testAnalysis.loading,
  err: state.testAnalysis && state.testAnalysis.error,
  errInfo:
    state.testAnalysis &&
    state.testAnalysis.errorInfo &&
    state.testAnalysis.errorInfo.data &&
    state.testAnalysis.errorInfo.data.message,
  errInfoStatus:
    state.testAnalysis &&
    state.testAnalysis.errorInfo &&
    state.testAnalysis.errorInfo.data &&
    state.testAnalysis.errorInfo.data.status,
  remainingTimeForShowResult:
    state.testAnalysis &&
    state.testAnalysis.errorInfo &&
    state.testAnalysis.errorInfo.data &&
    state.testAnalysis.errorInfo.data.time_remaining,
  answers:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response.user_responses &&
    state.testAnalysis.response.user_responses,
  testQuestions:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response.user_responses &&
    state.testAnalysis.response.user_responses,
  totalQuestions:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response,
  wrongQuestions:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response,
  unansweredQuestions:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response.unanswered_questions,
  correctQuestions:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response,
  attemptUser:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response,
  userScore:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response,
  winner:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response.winner,
  userSubject:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response.subject &&
    state.testAnalysis.response.subject,
  userSubjectId:
    state.testAnalysis &&
    state.testAnalysis.response &&
    state.testAnalysis.response.subject &&
    state.testAnalysis.response.subject_id,
  // totalQuestions: state.submitTest && state.submitTest.Total_Questions && state.submitTest.Total_Questions,
  _score:
    state.submitTest &&
    state.submitTest.response &&
    state.submitTest.response.score &&
    state.submitTest.response.score,
  questionReportLoading: state.questionReport && state.questionReport.loading,
  questionReportError: state.questionReport && state.questionReport.error,
  questionReportErrorInfo:
    state.questionReport && state.questionReport.errorInfo,
  sendQuestionReport:
    state.questionReport &&
    state.questionReport.response &&
    state.questionReport.response.status,
  requestedTestId: state.testAnalysis && state.testAnalysis.requestedTestId,
});
export default connect(maps, {
  testAnalysis,
  clearTestAnalysisData,
  questionReport,
  clearQuestionReportData,
})(TestAnalysisScreen);
